<template>
  <transition name="modal">
    <div id="container-floating">
      <div :class="`z-helper ${zIcon}`" style="position: relative">
        <transition name="fade">
          <div class="z-message pa-3" v-if="showModal">
            <button type="button" class="close" @click="onClose">
              <span aria-hidden="true">&times;</span>
            </button>
            <!-- <p style="font-weight: 600;" class="primary--text">
              {{ $t('We will go through the covid crisis together. Z is worried.') }}
            </p> -->

            <div
              v-if="false && selectedBot.note == 'ชดเชยวันหมดอายุ'"
              style="
                border: 1px solid #3fe83f;
                border-radius: 5px;
                padding: 10px;
                margin-bottom: 15px;
                background: #e1ffca;
              "
            >
              เนื่องจากช่วงเช้าในวันที่ 3 กุมภาพันธ์ 2564 ที่ผ่านมา ZWIZ.AI ได้มีการอัพเกรดระบบ
              ส่งผลให้ต้องปิดระบบชั่วคราว ทีมงานต้องขออภัยอย่างยิ่งในความไม่สะดวกนี้นะคะ
              และเพื่อเป็นการชดเชยให้กับลูกค้า ทีมงาน ZWIZ.AI จึงทำการ<span
                class="primary--text font-weight-bold"
                >เพิ่มแพ็กเกจพรีเมี่ยมให้กับลูกค้าทุกท่านเป็นจำนวน 30 วัน</span
              >ค่ะ <br />
              <br />

              <div class="caption">ZWIZ.AI TEAM</div>
            </div>

            <span v-if="selectedBot.theme == 'ecommercebasic'">
              <p>
                <!-- {{ $t('Users can follow new features.') }} -->
                {{ $t('bot_z_message.hello') }}
              </p>
              <p @mouseover="hoverzIcon('')">
                <!-- {{ $t('Users can follow new features.') }} -->
                {{ $t('bot_z_message.Catch up with new features') }}
                <a @click="goNavLink('/home?page=platformupdate')">{{ $t('Click here') }}</a>
              </p>
              <div @mouseover="hoverzIcon('')" class="black--text" style="font-weight: 600; position: relative; width: fit-content; margin-bottom: 16px;" >
                <!-- {{ $t('Special feature - broadcast to recipients') }}
                <a
                  :href="'https://blog.zwiz.app/specialbroadcast/?utm_source=NTNC_CMS'"
                  target="blank"
                  >{{ $t('Click here') }}</a
                > -->
                {{ $t('bot_z_message.Or request a demo') }}
                <a :href="'https://zerva.app/th/zwizdemo'" class="primary--text" target="blank">
                  {{ $t('Click here') }}
                </a>
                <img class="img-mouse" src="/static/img/mouse.svg" width="20px" />
              </div>
            </span>

            <div>
              <template>
                <!-- <a :href="'https://m.me/' + selectedBot.pageid + '?ref=menu'" target="blank">{{
                  $t('test this bot')
                }}</a> -->
                <a @click="startTestbot" @mouseover="hoverzIcon('testbot')">{{
                  $t('test this bot')
                }}</a>
                |
              </template>
              <!-- <template v-else>
                <a href="javascript:void(0)" @click="toggleBotStatus">{{ $t('start your bot') }}</a>
                |
              </template> -->
              <a
                @mouseover="hoverzIcon('helper')"
                href="https://blog.zwiz.app/getstarted-zwizai/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('help') }}</a
              >
              |
              <a
                @mouseover="hoverzIcon('comment')"
                href="https://m.me/361231620965547?ref=Complaints"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('Feedback') }}</a
              >
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div id="messages" class="z-message" v-if="showChat" style="overflow: hidden">
            <div
              class="white--text"
              :style="{
                'background-color':
                  channel == 'facebook' ? '#4267B2' : channel == 'line' ? '#00c300' : '#C13584'
              }"
            >
              <v-layout>
                <v-flex class="pl-2 pt-2">{{ selectedBot.pagename }}</v-flex>
                <v-flex shrink v-if="selectedBot.status">
                  <v-btn
                    v-if="channel == 'facebook'"
                    fab
                    small
                    flat
                    class="ma-0 text-xs-center"
                    :href="
                      'https://m.me/' +
                        (selectedBot.facebook_page_id
                          ? selectedBot.facebook_page_id
                          : selectedBot.pageid) +
                        '?ref=menu'
                    "
                    target="blank"
                  >
                    <v-icon color="white">ios_share</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex shrink>
                  <v-btn fab small flat class="ma-0" @click="onClose">
                    <v-icon color="white">close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex shrink class="text-xs-left pl-2 mb-2">
                  <v-menu offset-y open-on-hover offset-overflow right>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="
                          font-size: 15px;
                          border: 1px solid white;
                          border-radius: 50px;
                          padding-left: 11px;
                          text-transform: uppercase;
                        "
                      >
                        <i
                          class="white--text fab"
                          :class="{
                            'fa-facebook-square': channel == 'facebook',
                            'fa-line': channel == 'line',
                            'fa-instagram': channel == 'instagram'
                          }"
                        ></i>
                        {{ $t(channel) }}<v-icon color="white">expand_more </v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in channels"
                        :key="index"
                        @click="onChangeChannel(item)"
                        style="text-transform: uppercase;"
                      >
                        <v-list-tile-title class="primary-color">
                          {{ $t(item) }}
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
            </div>
            <v-divider></v-divider>

            <v-responsive id="testChat" style="overflow: auto" width="300" height="320">
              <div class="pa-2">
                <template v-for="(msg, i) in messages">
                  <message-item
                    @click-btn-message="clickBtnMessage"
                    :isBotTest="true"
                    :key="'message-' + i"
                    :id="`message_${i}`"
                    v-model="messages[i]"
                    :app="channel"
                  ></message-item>
                </template>
              </div>
            </v-responsive>

            <template v-if="quick_reply">
              <div
                class="quickreply text-xs-center pa-1"
                style="overflow-x: auto; white-space: nowrap; max-width: 300px"
              >
                <template v-if="quick_reply.length > 0">
                  <ul class="tags">
                    <li
                      style="cursor:pointer"
                      class="tag"
                      v-for="(reply, index) in quick_reply"
                      :key="'reply_' + index"
                      @click="clickBtnMessage(reply)"
                    >
                      {{ reply }}
                    </li>
                  </ul>
                </template>
              </div>
            </template>
            <v-divider />

            <v-layout>
              <v-flex class="pa-1">
                <autoresize-textarea
                  v-model="text"
                  rows="1"
                  placeholder="Type message"
                  style="
                    resize: none;
                    border: 1px solid #eee;
                    padding: 5px;
                    border-radius: 5px;
                    outline: 0px;
                    background: none;
                    display: inline-block;
                  "
                  @pressEnter="$refs.sendBtn.click()"
                  @onPaste="onPaste"
                ></autoresize-textarea>
              </v-flex>

              <v-flex shrink class="text-xs-right" style="white-space: nowrap">
                <template>
                  <!-- Send reply message -->
                  <span>
                    <v-btn
                      ref="sendBtn"
                      depressed
                      fab
                      color="primary"
                      small
                      :disabled="false"
                      @click="clickSendBtn"
                    >
                      <i class="fa fa-send"></i>
                    </v-btn>
                  </span>
                </template>
              </v-flex>
            </v-layout>
          </div>
        </transition>

        <div class="floating-btn" @click="clicktooltip">
          <div style="position: relative; width: 100%; height: 100%">
            <div v-if="hasupdate" class="numnew">!</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import carousel from 'vue-owl-carousel'
import { mapGetters } from 'vuex'
import messageItem from '../view/livechat/livechat-message'
import AutoresizeTextarea from '../view/livechat/AutoresizeTextarea'
import api from '@/api'
import { cloneDeep } from 'lodash'
import EventBus from '@/utils/event-bus.js'

export default {
  components: { carousel, messageItem, AutoresizeTextarea },
  data: function() {
    return {
      zIcon: '',
      newfeature: 'ntn',
      hasupdate: false,
      showFinish: false,
      activeChat: 1,
      text: '',
      contextOut: ''

      // welcomeMessage: [[]]
    }
  },
  computed: {
    ...mapGetters({
      showModalWelcome: 'showModalWelcome',
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    channels() {
      let channels = ['facebook', 'line', 'instagram']
      channels = channels.filter(el => {
        return this.selectedBot.packages.includes(el)
      })
      return channels
    },
    quick_reply() {
      if (
        this.messages &&
        this.messages.length > 0 &&
        this.messages[this.messages.length - 1].quick_reply
      ) {
        try {
          let quick_reply = this.messages[this.messages.length - 1].quick_reply
          return quick_reply.split(',')
        } catch (error) {}
        return null
      } else {
        return null
      }
    },
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage2(this.channel)
      return messages
    },
    messages() {
      return this.$store.state.test_bot.messages
    },
    channel() {
      return this.$store.state.test_bot.channel
    },
    welcome_intent: {
      get() {
        var welcome_intent = this.$store.getters.getIntents('welcome')
        welcome_intent = welcome_intent.length > 0 ? welcome_intent[0] : false
        if (welcome_intent == false) {
          welcome_intent = {
            ...cloneDeep(this.intentTemplate()),
            intentname: '{welcome}',
            a_val: '[[]]',
            ableToDelete: false,
            isShow: false
          }
        }
        return welcome_intent
      },
      set(val) {
        this.$store.commit('SET_INTENT', val)
      }
    },

    showModal() {
      return this.$store.state.showWelcomeModal
    },
    showChat() {
      return this.$store.state.test_bot.showChat
    }
  },
  async created() {
    // await this.$store.dispatch('loadIntent')
    // if (!this.welcomeMessage) this.welcomeMessage = await this.getWelcomeMessage()
  },
  mounted: function() {
    var vm = this

    this.$store.commit('SET_SHOW_WELCOME_MODAL', vm.showModalWelcome)
    // if (this.selectedBot.note == 'ชดเชยวันหมดอายุ') {
    //   this.newfeature = 'ชดเชยวันหมดอายุ030221'
    // }
    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.$store.commit('SET_SHOW_WELCOME_MODAL', false)
      }
    })
    this.checkupdate()

    if (this.channels.length > 0) {
      this.onChangeChannel(this.channels[0])
    }
  },
  methods: {
    async onPaste(evt) {
      if (evt.clipboardData.getData('text') && evt.clipboardData.getData('text').trim() != '') {
        this.text = this.text + evt.clipboardData.getData('text').trim()
      }
    },
    hoverzIcon(param) {
      this.zIcon = param
    },
    async setWelcome() {
      var welcome = []
      if (
        this.welcome_intent.fb_val ||
        this.welcome_intent.line_val ||
        this.welcome_intent.ig_val
      ) {
        if (this.channel == 'facebook') {
          try {
            var fb_val = JSON.parse(this.welcome_intent.fb_val)
            if (fb_val && fb_val.length > 0) {
              var rand = Math.floor(Math.random() * fb_val.length)
              welcome = fb_val[rand]
            }
          } catch (error) {}
        } else if (this.channel == 'instagram') {
          try {
            var ig_val = JSON.parse(this.welcome_intent.ig_val)
            if (ig_val && ig_val.length > 0) {
              var rand = Math.floor(Math.random() * ig_val.length)
              welcome = ig_val[rand]
            }
          } catch (error) {}
        } else {
          try {
            var line_val = JSON.parse(this.welcome_intent.line_val)
            if (line_val && line_val.length > 0) {
              var rand = Math.floor(Math.random() * line_val.length)
              welcome = line_val[rand]
            }
          } catch (error) {}
        }
      } else {
        try {
          var rand = Math.floor(Math.random() * this.welcomeMessage.length)
          welcome = this.welcomeMessage[rand]
        } catch (error) {
          console.log(error)
        }
      }
      let quick_reply = ''
      try {
        quick_reply = this.$store.getters.getIntents('welcome')[0].quick_reply
      } catch (error) {}
      this.$store.commit('ADD_MESSAGE_TEST', {
        messagedata: JSON.stringify(welcome),
        messagetype: 'json',
        answerby: 'test',
        quick_reply: quick_reply
      })

      await this.$nextTick()
      try {
        this.scrollToEnd()
      } catch (error) {}
    },
    onChangeChannel(value) {
      this.$store.commit('SET_CHANNEL', value)
      this.$store.commit('SET_MESSAGE_TEST', [])
      this.setWelcome()
    },
    clickBtnMessage(text) {
      if (typeof text === 'string') {
        this.text = text
      } else {
        this.text = text.payload || text.title
      }
      this.clickSendBtn()
    },
    getWelcomeMessage() {
      let data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(JSON.parse(response.data.message))
        })
      })
    },
    scrollToEnd: function() {
      var container = this.$el.querySelector('#testChat div.v-responsive__content')
      container.scrollTop = container.scrollHeight
      var container1 = this.$el.querySelector('#testChat')
      container1.scrollTop = container.scrollHeight
    },
    async clickSendBtn() {
      var vm = this
      try {
        await this.$store.dispatch('sendMessageToServer', {
          text: this.text,
          clearText: () => {
            vm.text = ''
          },
          scrollbottom: () => {
            vm.$nextTick(() => {
              vm.scrollToEnd()
            })
          }
        })
      } catch (error) {}

      vm.$nextTick(() => {
        vm.scrollToEnd()
      })
      vm.enableSend = false
    },
    startTestbot() {
      this.$store.commit('SET_SHOW_TEST_CHAT', true)
    },
    checkupdate() {
      var value = this.$localStorage.get('newupdate')
      if (value) {
        var feature = JSON.parse(value)
        if (feature.update == this.newfeature) {
          this.hasupdate = !feature.readed
        } else {
          this.hasupdate = true
        }
      } else {
        this.hasupdate = true
      }
    },
    clicktooltip() {
      this.$store.commit('SET_SHOW_WELCOME_MODAL', true)
      var data = { update: this.newfeature, readed: true }
      this.$localStorage.set('newupdate', JSON.stringify(data))
      this.hasupdate = false
    },
    goNavLink(link) {
      this.$router.push('/' + this.$store.getters.currentLang + link).catch(() => {})
    },
    changed: function(event) {
      this.showFinish = event.item.index == event.item.count - 1
    },
    updated: function() {},
    onClose: function() {
      this.$store.commit('SET_SHOW_WELCOME_MODAL', false)
      this.$store.commit('SET_SHOW_TEST_CHAT', false)

      this.$store.dispatch('clearModalWelcome')

      EventBus.$emit('close:welcome', true)
    },
    toggleBotStatus: function() {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status

      let in_status_label = bot.status ? 'stop' : 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function(index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    showChat: async function(newVal) {
      if (newVal === true) {
        await this.$nextTick()
        try {
          this.scrollToEnd()
        } catch (error) {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.numnew {
  width: 22px;
  height: 22px;
  background-color: red;
  border: 1.2px solid white;
  color: white;
  border-radius: 99px;
  font-weight: 800;
  margin-left: auto;
  text-align: center;
}
$dur: 1s;
$delay: $dur/2;

.img-mouse {
  position: absolute;
  bottom: -10px;
  right: -20px;
  animation: circleScale $dur infinite;
  animation-delay: $delay;
}

@keyframes circleScale {
	0% {transform: scale(0.8)  }
	50% { transform: scale(1) }
  100% { transform: scale(0.8) }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ModalWelcome.vue